import React, { useState, useEffect } from "react";
import axios from "axios";
import Slider from "react-slick";
import { v4 as uuidv4 } from "uuid";
import "../styles/ProductCarousel.css"; // Reuse the same CSS
import ProductCard from "../components/ProductCard"; // Reuse the same ProductCard

const STIHLProductsCarousel = ({ cart, setCart, guestCartId, isLoggedIn }) => {
  const [displayProducts, setDisplayProducts] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (!isLoggedIn && !localStorage.getItem("guestCartId")) {
      const newGuestCartId = uuidv4();
      localStorage.setItem("guestCartId", newGuestCartId);
    }

    fetchSTIHLProducts();
  }, [isLoggedIn]);

  const fetchSTIHLProducts = async () => {
    try {
      // Step 1: Fetch the category ID for "STIHL"
      const categoriesResponse = await axios.get( `${API_BASE_URL}/api/products/categories`);
      const categories = categoriesResponse.data;

      // Find the STIHL category by name
      const stihlCategory = categories.find((category) => category.name === "STIHL");

      if (!stihlCategory) {
        console.error("STIHL category not found");
        setDisplayProducts([]);
        return;
      }

      // Step 2: Fetch products belonging to the STIHL category
      const productsResponse = await axios.get(
         `${API_BASE_URL}/api/products/category/${stihlCategory.id}`
      );

      // Ensure only unique products are displayed
      const uniqueProductsMap = new Map();
      productsResponse.data.forEach((product) => {
        if (product?.id) {
          uniqueProductsMap.set(product.id, product);
        }
      });

      const uniqueProducts = Array.from(uniqueProductsMap.values()).slice(0, 5); // Limit to 5 products
      setDisplayProducts(uniqueProducts);
    } catch (error) {
      console.error("Error fetching STIHL products:", error);
      setDisplayProducts([]);
    }
  };

  const addToCart = (product) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    let guestCartId = localStorage.getItem("guestCartId");

    const price = product.onSale
      ? product.price * (1 - product.discountPercentage / 100)
      : product.price;

    if (!isLoggedIn && !guestCartId) {
      const newGuestCartId = uuidv4();
      localStorage.setItem("guestCartId", newGuestCartId);
      guestCartId = newGuestCartId;
    }

    const payload = isLoggedIn
      ? { productId: product.id, quantity: 1, userId, price }
      : { productId: product.id, quantity: 1, guestCartId, price };

    fetch( `${API_BASE_URL}/cart/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? "Bearer " + token : "",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to add to cart");
        alert("Product added to cart!");
      })
      .catch((error) => {
        console.error("Error adding item to cart:", error);
        alert("Error adding item to cart: " + error.message);
      });
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: displayProducts.length > 5,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="product-carousel">
      <h2>STIHL proizvodi</h2>
      {displayProducts.length > 0 ? (
        <Slider {...settings}>
          {displayProducts.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onAddToCart={() => addToCart(product)}
            />
          ))}
        </Slider>
      ) : (
        <p>No STIHL products available at the moment.</p>
      )}
    </div>
  );
};

export default STIHLProductsCarousel;